import classNames from 'classnames';
import styles from './progress.module.scss';

export interface ProgressBarProps {
    progress: number;
    max?: number;
    className?: string;
    showText?: boolean;
}

const ProgressBar = ({
    progress,
    max,
    showText,
    className,
}: ProgressBarProps) => (
    <div className={classNames(styles['bar'], className)}>
        <progress value={progress} max={max}></progress>
        {showText ? (
            <span style={{ width: progress + '%' }}>{progress + '%'}</span>
        ) : null}
    </div>
);

export default ProgressBar;
